module.exports = __webpack_public_path__ + "img/gs.b545e9db.png";